import React, { Component } from "react";
import _ from 'i18n';
import {formatAmount, formatNumber} from "../../../../services/utils";
import {CommonLoader} from "../../../common/CommonLoader";



export default class EventLineChartDetails extends Component {

  calculateTotal = () =>{
    const {data, chartLinesToShow} = this.props;
    
    return data.reduce(function (tot, record) {

      return chartLinesToShow.reduce((tot, line) => {
        return tot + record[line];
      }, tot);

      //return tot + record.formations + record.cycles + record.saisons + record.premium + record.congrès;
    }, 0);
  }

  

  render() {

    const {data, fetching, isError, type} = this.props;
    return (
      <div>
        {(fetching === false && isError === false) ? (
          <div className={'chart-registrant-number'}>
            {type === 'CA' ? formatAmount(this.calculateTotal()) : formatNumber(this.calculateTotal())}
          </div>) : (
          <CommonLoader containerHeight={"40px"} iconFontSize={"20px"}
                        iconColor={"#29394D"}/>)
        }
        <div className={'chart-registrant-number-label mb-2'}>
          {type === 'REGISTRATION' ? _('REGISTRATIONS_TOTAL_NUMBER') : _('CA_TOTAL_NUMBER')}
        </div>
        {/*<div className={'chart-registrant-period'}>Vos analyses commencent à partir de 01/01/2021</div>*/}
      </div>
    );
  }
}







// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventLineChartDetails.js